import React, { useContext } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { formatCurrency } from 'util/Currency';
import { evenRound } from 'util/NumberUtils';
import { TenantContext } from '../../tenant/TenantContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { PaymentCartContext } from './PaymentCartContext';

const DonationFragment = ({ paymentCartItem, idx, allowDelete }) => {
    const { businessConfig } = useContext(TenantContext);
    const { removeFromCart } = useContext(PaymentCartContext);

    const removePmtItemFromCart = async () => {
        //console.log("removing from paymentcart", paymentCartItem);
        await removeFromCart(paymentCartItem.id);
    }

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <div>
                        <strong>Donation</strong>
                        {allowDelete && <Button variant="dark" className="border-0 text-dark" onClick={removePmtItemFromCart}>
                            <FontAwesomeIcon icon={faTrash} title="Delete from cart" />
                        </Button>}
                    </div>
                </Col>
            </Row>
            <Row key={idx}><Col>
                {paymentCartItem.itemDetail.lineItems.map((lineItem, donIdx) => (
                    <Row key={'bli' + donIdx}>
                        <Col>
                            <div><span>{lineItem.lineItemDescription}</span> </div>
                        </Col>
                        <Col>
                            <div><span>{formatCurrency(evenRound(lineItem.lineItemAmount / 100, 2), businessConfig.locale, businessConfig.currency)}</span> </div>
                        </Col>
                    </Row>
                ))}

            </Col></Row>
        </React.Fragment>
    )
}

export default DonationFragment